import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

export const getStockReport = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/PurchaseOrder/get-stock-report`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching stock report:", error);
    throw error;
  }
};

export const getProductStockSummary = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/PurchaseOrder/get-product-stock-summary`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching product stock summary:", error);
    throw error;
  }
};

// API to export stock summary report to Excel
export const exportStockSummaryToExcel = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/PurchaseOrder/export-stock-summary-excel`, filter, {
      headers: getAuthHeader(),
      responseType: 'blob'
    });
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `StockSummaryReport_${new Date().toISOString().slice(0,19).replace(/[-:]/g, '').replace('T', '_')}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error("Error exporting stock summary report:", error);
    throw error;
  }
};

// API to export stock details for a specific product to Excel
export const exportStockDetailsToExcel = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/PurchaseOrder/export-stock-details-excel`, filter, {
      headers: getAuthHeader(),
      responseType: 'blob'
    });
    
    // Get filename from Content-Disposition header if available, otherwise use default
    let filename = `StockDetails_${new Date().toISOString().slice(0,19).replace(/[-:]/g, '').replace('T', '_')}.xlsx`;
    const contentDisposition = response.headers['content-disposition'];
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="?(.+)"?/i);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1];
      }
    }
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error("Error exporting stock details:", error);
    throw error;
  }
};
